import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

import { CasinoLink } from './CasinoLink.jsx'



export class Menu extends React.Component {

    constructor(props) {
        super(props);
        this.getClassNames = this.getClassNames.bind(this);
    }

    getClassNames() {
        return this.props.showMenu ? 'active' : '';
    }

    render() {
        return <aside className={this.getClassNames()} id="menu">
            <ul>
                {this.props.renderMenuFn(true)}
            </ul>
            <div className="social-networks">
                <a href="https://www.facebook.com/supersport.hr" target="_blank"><span className="icon ico-facebook"></span></a>
                <a href="https://www.instagram.com/supersport.hr/" target="_blank"><span className="icon ico-instagram"></span></a>
            </div>
            <div className="helper"></div>
        </aside>

    }
};
